"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenLogin = exports.Name = void 0;
const Name = exports.Name = 'open-login';
const OpenLogin = exports.OpenLogin = Name;
//# sourceMappingURL=event.js.map